<template>
	<NcAppContent class="loading" />
</template>
<script>

import {
	NcAppContent,
} from '@nextcloud/vue'

export default {
	name: 'Loading',

	components: {
		NcAppContent,
	},
}

</script>
